// src/frontend/pages/SolidityViewer.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const TITLE_BLUE = "#175cd3";
const SIDEBAR_BG = "#f7f9fb";
const SIDEBAR_BORDER = "#e6ebf1";

const solidityVideos = [
  { id: 1, title: "¿Quién es Solidity y para qué sirve?",                 embed: "https://drive.google.com/file/d/1uEajMxdW61gsY_GSDgtc1OOkFJtVMTEc/preview" },
  { id: 2, title: "Estructura de un contrato en Solidity",                 embed: "https://drive.google.com/file/d/1RMin2X7b5xtbweSd26_CrsNVqTON72Gr/preview" },
  { id: 3, title: "Estructuras de control en Solidity",                    embed: "https://drive.google.com/file/d/1HdZaS2WSJ-QaFEV6c7xrDaX0F4m_rVUC/preview" },
  { id: 4, title: "Tipos de variables en Solidity",                        embed: "https://drive.google.com/file/d/1pt25wa4mgxxzW7F2nwvqyIbi7oky88Gl/preview" },
  { id: 5, title: "Funciones",                                             embed: "https://drive.google.com/file/d/11vRVlNDZM_KjpmJX09xwtgPaSVBMCa-R/preview" },
];

export default function SolidityViewer() {
  const { videoId } = useParams();
  const navigate = useNavigate();

  const [selected, setSelected] = useState(() => {
    return solidityVideos.find((v) => v.id === Number(videoId)) || solidityVideos[0];
  });

  useEffect(() => {
    const found = solidityVideos.find((v) => v.id === Number(videoId));
    if (found) setSelected(found);
  }, [videoId]);

  const handleSelect = (video) => navigate(`/course/solidity/${video.id}`);

  return (
    <div className="vv-serif-root vv-wrap">
      <style>{`
        /* Usa --header-offset si tienes navbar fijo (ej. 64px) */
        :root { --header-offset: var(--header-offset, 0px); }

        .vv-serif-root, .vv-serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: .01em;
        }
        .vv-wrap {
          display: flex;
          min-height: calc(100dvh - var(--header-offset));
          background: #fff;
        }

        /* Sidebar */
        .vv-sidebar {
          width: 280px;
          background: ${SIDEBAR_BG};
          border-right: 1px solid ${SIDEBAR_BORDER};
          position: sticky;
          top: var(--header-offset);
          height: calc(100dvh - var(--header-offset));
          overflow: auto;
        }
        .vv-title {
          background: ${TITLE_BLUE};
          color: #fff;
          font-weight: 800;
          font-size: 15px;
          padding: 14px 12px;
          margin: 0 0 12px 0;
          text-align: left;
        }
        .vv-subtitle {
          color: #102a43;
          font-weight: 700;
          font-size: 13px;
          padding: 0 12px 8px 12px;
        }
        .vv-items { list-style: none; margin: 0; padding: 0 6px 12px 6px; }
        .vv-itemBtn {
          all: unset;
          display: grid;
          grid-template-columns: 12px 1fr auto;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 8px 10px 8px 6px;
          margin: 2px 4px;
          color: #243b53;
          cursor: pointer;
          text-align: left;
        }
        .vv-itemBtn:hover { background: #ffffff; }
        .vv-itemLabel {
          font-size: 13px; line-height: 1.2;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .vv-itemActive .vv-itemLabel { color: ${TITLE_BLUE}; font-weight: 800; }
        .vv-check { font-size: 12px; font-weight: 900; color: ${TITLE_BLUE}; padding: 0 2px; }

        /* Viewer */
        .vv-viewer {
          flex: 1;
          display: flex;
          align-items: start;         /* evita que “se vaya abajo” */
          justify-content: center;
          padding: 16px clamp(12px, 2vw, 24px);
          margin-top: var(--header-offset); /* respeta navbar fijo */
        }
        .vv-frameWrap { width: 95%; max-width: 960px; margin: 0 auto; }
        .vv-iframe { width: 100%; height: 520px; border: 0; }

        @media (max-width: 900px) {
          .vv-sidebar { width: 240px; }
          .vv-iframe { height: 420px; }
        }
        @media (max-width: 720px) {
          .vv-wrap { flex-direction: column; }
          .vv-sidebar {
            position: relative;
            top: 0;
            height: auto;
            border-right: none;
            border-bottom: 1px solid ${SIDEBAR_BORDER};
          }
          .vv-viewer { margin-top: 0; }
          .vv-iframe { height: 360px; }
        }
      `}</style>

      {/* Sidebar */}
      <aside className="vv-sidebar" aria-label="Navegación de la Semana 1">
        <h1 className="vv-title">SOLIDITY</h1>
        <div className="vv-subtitle">Semana Uno</div>

        <ul className="vv-items">
          {solidityVideos.map((video) => {
            const active = selected.id === video.id;
            return (
              <li key={video.id}>
                <button
                  className={`vv-itemBtn ${active ? "vv-itemActive" : ""}`}
                  onClick={() => handleSelect(video)}
                  aria-current={active ? "page" : undefined}
                >
                  <span aria-hidden="true" />
                  <span className="vv-itemLabel">{video.title}</span>
                  {active && <span className="vv-check">✓</span>}
                </button>
              </li>
            );
          })}
        </ul>
      </aside>

      {/* Video */}
      <main className="vv-viewer">
        <div className="vv-frameWrap">
          <iframe
            key={selected.id}
            src={selected.embed}
            className="vv-iframe"
            allow="autoplay"
            allowFullScreen
            title={selected.title}
          />
        </div>
      </main>
    </div>
  );
}
